import { ScrollableArea } from "@nova/component-scrollable-area"
import { footerHeight, navbarHeight } from "@nova/constants"
import { FirePerimeterAuto } from "plugins/DrawPerimeter/plugin-actions/methods/auto/FirePerimeterAuto"

export const InspectorPanelFirePerimeterUpdateAuto = () => {
    return (
        <div
            className="pl-4 overflow-y-hidden min-h-0 flex-1 flex py-2"
            style={{
                maxHeight: `calc(${window.innerHeight - navbarHeight - footerHeight}px - 11rem)`,
            }}
        >
            <ScrollableArea shouldPreventScrollbarShifting className="w-full pr-4">
                <FirePerimeterAuto shouldShowConfirmControls={false} />
            </ScrollableArea>
        </div>
    )
}
